import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with cookie support
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Handle auth errors - redirect to login on 401 (except auth check endpoints)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config.url?.includes('/auth/')) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
};

// Client APIs
export const clientAPI = {
  getProfile: () => api.get('/client/profile'),
  updateProfile: (data) => api.put('/client/profile', data),
  getDocuments: () => api.get('/client/documents'),
  uploadDocument: (documentType, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/client/documents/upload?document_type=${documentType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  getUpdates: () => api.get('/client/updates'),
  getCreditItems: () => api.get('/client/credit-items'),
};

// Admin APIs
export const adminAPI = {
  getClients: () => api.get('/admin/clients'),
  getClientDetail: (clientId) => api.get(`/admin/clients/${clientId}`),
  updateClientStatus: (clientId, status) => 
    api.put(`/admin/clients/${clientId}/status?status=${status}`),
  createClientUpdate: (clientId, data) => 
    api.post(`/admin/clients/${clientId}/updates`, data),
  createCreditItem: (clientId, data) => 
    api.post(`/admin/clients/${clientId}/credit-items`, data),
  updateCreditItem: (itemId, status, notes) => 
    api.put(`/admin/credit-items/${itemId}?status=${status}${notes ? `&notes=${notes}` : ''}`),
  getStats: () => api.get('/admin/stats'),
};

// Payment APIs
export const paymentAPI = {
  createCheckout: (packageType) => {
    const originUrl = window.location.origin;
    return api.post('/payments/create-checkout', { origin_url: originUrl, package_type: packageType });
  },
  getPaymentStatus: (sessionId) => api.get(`/payments/status/${sessionId}`),
};

// Contact API
export const contactAPI = {
  submitMessage: (data) => api.post('/contact', data),
};

export default api;
